// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"t1-z","colorTextValue":"u1-z","swatches":"v1-z","collapseLink":"w1-z","isCollapsed":"x1-z","dropdown":"y1-z","disabled":"z1-z"};